import { useEffect, useState } from "react";
import { Div } from "../../Styles/Styled";
import ModalProduto from "../ModalProds";
import { Colors } from "../../config";

interface IProducts {
  kits?: any;
  extras?: IExtraProd[];
  width: number;
  chave: number;
  descricao: string;
  preco_venda: number;
  grupo1: string;
  grupo2: string;
  grupo3: string;
  tipo: string;
  picture: string;
  unidade: string;
  observacao: string;
}

interface IExtraProd {
  chave: number;
  descricao: string;
  ordem: number;
  quantidade: number;
  qme: number;
  preco_venda: number;
  chave_kit: number;
}


export default function Products(props: IProducts) {
  const [openDetail, setOpenDetail] = useState(false);
  const [prod, setProd] = useState<IProducts>({
    width: 0,
    chave: 0,
    descricao: "",
    preco_venda: 0,
    grupo1: "",
    grupo2: "",
    grupo3: "",
    tipo: "",
    picture: "",
    unidade: "",
    observacao: "",
  });

  const handleOpenModal = () => {
    const prod_att = prod;
    const kits:any[] = [];
    
    prod?.kits.forEach((kit:any) => {
      if (!kits.find((k) => k?.grupo_kit?.descricao === kit?.grupo_kit?.descricao)) {
        kits.push(kit);
      }
    });

    if (prod_att?.unidade === "KG") {
      const new_obj : any = {
        width: prod_att.width,
        chave: prod_att.chave,
        descricao: prod_att.descricao,
        preco_venda: 0,
        grupo1: prod_att.grupo1,
        grupo2: prod_att.grupo2,
        grupo3: prod_att.grupo3,
        tipo: prod_att.tipo,
        picture: prod_att.picture,
        unidade: prod_att.unidade,
        observacao: prod.observacao,
        kits,
        extras: prod?.extras || [],
      }
      setProd(new_obj)
    } else {
      const new_obj:any = {
        ...prod_att,
        kits
      }
      setProd(new_obj)
    }
    setOpenDetail(!openDetail);
  };

  useEffect(() => {
    setProd(props);
  }, [props]);

  return (
    <>
      {openDetail && (
        <ModalProduto
          onPressClose={() => handleOpenModal()}
          {...prod}
          open={openDetail}
        />
      )}
      <Div
        Content="center"
        Touch={true}
        onClick={() => handleOpenModal()}
        Items="center"
        style={{
          maxWidth: 200,
          overflowX: "hidden",
        }}
        borderRadius={{
          top: {
            left: "15px",
            right: "15px",
          },
          bottom: {
            left: "15px",
            right: "15px",
          },
        }}
        Padding={{
          bottom: "10px",
          top: "0px",
        }}
        Margin={{
          top: "10px",
          bottom: "10px",
          left: "10px",
          right: "10px",
        }}
        background={Colors.prodBackgroundColor}
        Width={props.width - 20 + "px"}
        border={{
          all: `2px solid ${Colors.prodBorderColor}`,
        }}
        Height={"auto"}
      >
        <img
          style={{
            width: props.width,
            height: 220,
            marginTop: -5,
            objectFit: "cover",
          }}
          onError={(e: any) => (e.target.src = "./notfound.png")}
          src={props.picture}
        />

        <Div
          Width={`${props.width - 30}px`}
          TextSize="14px"
          Items="left"
          Margin={{
            top: "10px",
            bottom: "10px",
          }}
          TextColor={Colors.prodTextColor}
          Text={`${props.descricao}`}
        />
        {props.preco_venda > 0 && (
          <Div
            Width={`${props.width - 30}px`}
            row={true}
            TextSize="16px"
            TextColor={Colors.prodTextColor}
            Items="center"
          >
            <Div
              background="green"
              color="white"
              TextSize="16px"
              TextColor={Colors.prodTextColor}
              Width={"25px"}
              Height={"25px"}
              Content="center"
              Items="center"
              borderRadius={{
                top: { left: "20px", right: "20px" },
                bottom: { left: "20px", right: "20px" },
              }}
            >
              <span> R$ </span>
            </Div>
            <Div
              Margin={{
                left: "5px",
              }}
              TextSize="18px"
              TextColor={Colors.prodTextColor}
              Text={`${new Intl.NumberFormat("pt-BR", {
                minimumFractionDigits: 2,
              }).format(props.preco_venda)}`}
            />
          </Div>
        )}

        {props.preco_venda <= 0 && (
          <Div
            color="white"
            TextSize="16px"
            TextColor={Colors.prodTextColor}
            Width={"25px"}
            Height={"25px"}
            Content="center"
            Items="center"
          ></Div>
        )}
      </Div>
    </>
  );
}
